import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useEditWorkExperienceStyle = makeStyles()((theme: Theme) => ({
  root: {
    padding: '0px 0px',
  },
  textColor: {
    paddingTop: 8,
    paddingLeft: 0,
  },
  action: {
    display: 'flex',
    flexDirection: 'row',
  },
  actionBtn: {
    fontSize: 12,
    padding: 0,
    minWidth: 30,
  },
  actionNoBtn: {
    color: '#888888',
  },
  actionYesBtn: {
    color: '#009AD9 !important',
  },
  divider: {
    margin: '13px 16px 13px 16px',
  },
  alingmentField: {
    paddingRight: '25px !important',
  },
  currentlyWorking: {
    marginBottom: '-15px',
  },
  datePickerInput: {
    height: '55px',
  },
  checkBoxContainer: {
    marginBottom: '-30px',
  },
  checkBoxInput: {
    paddingTop: '26px !important',
  },
  buttonStyle: {
    color: '#611A16',
    fontSize: '14px',
    fontWeight: 500,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  infoIcon: {
    color: '#34AADC',
    height: '20px',
    width: '20px',
  },
  infoIconAlignment: {
    paddingTop: '30px !important'
  },
  label: {
    fontSize: '14px !important',
    color: 'rgba(0, 0, 0, 0.37)',
    '&.Mui-focused': {
      color: 'rgba(0, 0, 0, 0.37)',
    },
    '&[class*="MuiInputLabel-outlined"]': {
      marginTop: '1px',
    },
  },
}));
